import {createSelector} from 'reselect';

import {AppSelector} from '../../helpers/reselectHelpers';

/*
 * Selectors.
 */

export const getIsElectron: AppSelector<boolean> = (state) => Boolean(state.electron);

export const getCanSetMacOsTrafficLightPosition: AppSelector<boolean> = (state) =>
  Boolean(state.electron?.canSetMacOsTrafficLightPosition);

export const getCanHideWindowsTitleBar: AppSelector<boolean> = (state) =>
  Boolean(state.electron?.canHideWindowsTitleBar);

export const getIsApplicationMenuOpen: AppSelector<boolean> = (state) =>
  Boolean(state.electron?.isApplicationMenuOpen);

export const getIsMaximized: AppSelector<boolean> = (state) => Boolean(state.electron?.isMaximized);

export const getIsFullScreen: AppSelector<boolean> = (state) => Boolean(state.electron?.isFullScreen);

export const getZoomFactor: AppSelector<number | undefined> = (state) => state.electron?.zoomFactor;

/**
 * macOS traffic lights are visible if:
 *  - we have the corresponding method from the bridge, AND
 *  - we're not simulating the Windows title bar in development, AND
 *  - we're not in full screen (because traffic lights are merged with macOS menu bar).
 */
export const getAreMacOsTrafficLightsVisible: AppSelector<boolean> = createSelector(
  [getCanSetMacOsTrafficLightPosition, getCanHideWindowsTitleBar, getIsFullScreen],
  (canSetMacOsTrafficLightPosition, canHideWindowsTitleBar, isFullScreen) =>
    canSetMacOsTrafficLightPosition && !canHideWindowsTitleBar && !isFullScreen,
);
